import { observable, computed, extendObservable, action } from 'mobx';

export default class SaleEditStore {
  @observable page = 1;
  @observable offerData = {};
  @observable docs = [];

  user = null;

  constructor(user) {
    this.user = user;
  }

  @computed get isPage1Valid() {
    const data = this.offerData;
    return (
      !!data.object_type &&
      !!data.housing_company &&
      !!data.object_address &&
      !!data.shares
    );
  }

  @computed get isPage2Valid() {
    return true;
  }

  @computed get isPage3Valid() {
    return true;
  }

  @action initialize(offerData, docs) {
    this.offerData = Object.assign({}, offerData);
    this.docs = (docs || []).slice();
    extendObservable(this.offerData, {
      object_type: offerData.object_type || '',
      housing_company: offerData.housing_company || '',
      object_address: offerData.object_address || '',
      flat_number: offerData.flat_number || '',
      shares: offerData.shares || '',
      redemption_clause: offerData.redemption_clause || false,
      electronic_share: offerData.electronic_share || false,
      additional_description: offerData.additional_description || '',
      handover: offerData.handover || '',
    });
  }
}

export { SaleEditStore };



// WEBPACK FOOTER //
// ./src/app/@propnow/containers/Sale/SaleEditSection/_fi/stores/index.js